import { Component, OnInit, OnDestroy, Pipe, PipeTransform, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-ecommerce',
  templateUrl: './ecommerce.component.html',
  styleUrls: ['./ecommerce.component.css']
})
export class EcommerceComponent implements OnInit, OnDestroy, PipeTransform {

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private router: Router,
    private ngZone: NgZone
  ) { }

  plan;
  url;
  private sub;
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.plan = params['plan'];
      this.url = `${environment.API_BASE_URL}/gestion/ecommerce/${this.plan}/`;

      // Configurar la comunicación entre iframe y página principal
      window.addEventListener('message', (event) => {
        if (event.origin === environment.API_BASE_URL) {
          this.ngZone.run(() => {
            if (event.data.type === 'height') {
              const iframe = document.getElementById('miIframe') as HTMLIFrameElement;
              if (iframe) {
                // Ajustamos la altura máxima del iframe
                const maxHeight = window.innerHeight - 80; // 80px para el header
                const requestedHeight = event.data.height;
                iframe.style.height = `${Math.min(maxHeight, requestedHeight)}px`;
              }
            }
          });
        }
      });
    });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

}

